import React from "react";
import { motion } from "framer-motion";

const items = [
  { value: "Lifelong", label: "Practice & lived experience" },
  { value: "ES · EN", label: "Native bilingual fluency" },
  { value: "5", label: "Specializations served" },
  { value: "100%", label: "Confidential & ethical" },
];

export default function TrustStrip() {
  return (
    <section
      data-testid="trust-strip"
      className="border-y border-[hsl(var(--line))] bg-[hsl(var(--surface))]"
    >
      <div className="container-edge py-10 md:py-12 grid grid-cols-2 md:grid-cols-4 gap-y-8 gap-x-6">
        {items.map((it, i) => (
          <motion.div
            key={it.label}
            initial={{ opacity: 0, y: 12 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.5, delay: i * 0.06 }}
            className="md:border-l md:first:border-l-0 md:pl-6"
            data-testid={`trust-item-${i}`}
          >
            <div className="font-display text-2xl md:text-3xl text-[hsl(var(--ink))] tracking-tight">
              {it.value}
            </div>
            <div className="mt-1 text-sm text-[hsl(var(--text-muted))] leading-relaxed">
              {it.label}
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
